import {useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';

// Layouts persist across sibling routes, so scroll-to-top must follow pathname, not mount
export default function useScrollToTop() {
  const {pathname, state} = useLocation();
  useLayoutEffect(() => {
    if (state && state.preserveScroll) return;
    window.scrollTo(0, 0);
  }, [pathname]);
}
